module.exports = __webpack_public_path__ + "static/img/ic_login@3x.b4b7b36.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login/ic_login@3x.png
// module id = AmhB
// module chunks = 1